import { useContext, useEffect } from "react";
import { IoMdSearch } from "react-icons/io";
import { MyContext } from "../context/myContext";

function Searchbar({ apiUrl, updateItemData, searchVal, setSearchVal }) {

  const { workItemClicked, setWorkItemClicked, selectedProduct } = useContext(MyContext);
  const handleSearchButton = async (event) => {
    try {
      if (searchVal) {
        const response = await apiUrl.request(searchVal, selectedProduct);
        const data = response?.data;
        updateItemData(searchVal, data);
      }
    } catch (error) {
      console.error("Error while calling the API:", error);
      updateItemData(searchVal, '');
    }
  };

  const handleOnChangeSearchKey = (event) => {
    setSearchVal(event.target.value);
  };

  useEffect(() => {
    if (workItemClicked) {
      handleSearchButton();
      setWorkItemClicked(false)
    }
  }, [workItemClicked]);

  useEffect(() => {
    if (!workItemClicked && searchVal) {
      handleSearchButton();
    }
  }, [searchVal])

  return (
    <div>
      <div className="flex justify-between items-center border-2 border-slate-950 rounded-3xl p-2 text-base">
        {/* back section */}
        <div className="mr-5 bg-transparent border-none">
          {/* Disabled back button */}
          {/* <a id="backButton" href="/">
            <IoMdArrowRoundBack size={25} />
          </a> */}
        </div>

        {/* input section */}
        <div className="flex-grow w-[100%] ml-5 bg-transparent border-none">
          <input
            id="searchKey"
            className="w-[100%] bg-transparent border-none outline-none"
            placeholder="Enter the Work Item ID"
            value={searchVal} // Control the input with searchVal
            onChange={handleOnChangeSearchKey}
            onKeyDown={(event) => {
              if (event.key === "Enter") {
                handleSearchButton();
              }
            }}
          />
        </div>

        {/* search section */}
        <div className="mr-5 bg-transparent border-none">
          <button id="searchButton" onClick={handleSearchButton}>
            <IoMdSearch size={30} />
          </button>
        </div>
      </div>
    </div>
  );
}

export default Searchbar;
